<template>
  <v-card
    elevation="10"
    width="100%"
    :loading="false"
  >
    <v-card-title>
      Meu armazenamento
      <v-spacer/>
    </v-card-title>
    <v-card-text>
        <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
            v-if="isLoading"
        ></v-progress-circular>

        <v-progress-linear
            :value="storage.percentage_used"
            height="35"
            width="150"
            v-else
        >
            <strong>Total utilizado: {{ Math.ceil(storage.bytes_used/1000000000) }} GB - {{ Math.ceil(storage.percentage_used) }}%</strong>
        </v-progress-linear> 

        <v-chip
            class="ma-2"
            color="success"
            
            v-if="!isLoading"
        >
        <v-icon left>
            mdi-server-plus
        </v-icon>
        <strong>Total disponível: {{ Math.ceil((storage.max_bytes-storage.bytes_used)/1000000000) }} GB</strong>
        </v-chip>              
    </v-card-text>
  </v-card>
</template>

<script>
  import {listSpaceUsed} from "../../api/api-billing"

  export default {
    name: "MyStorage",
    data: () => ({
        isLoading: false,
        storage: null,
    }),
    filters: {},
    computed: {},
    created() {
      this.isLoading = true

      listSpaceUsed(this.$apiAuth.getAuthToken())
        .then(res => {
          const usedSpace = res.data.data
          this.storage = usedSpace
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
</script>

<style scoped lang="scss">
</style>
